import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOktaAuth } from '@okta/okta-react';
import { useIsAuthorized } from './useIsAuthorized';

export function RequireAuth({ children }: Readonly<{ children: JSX.Element }>) {
  const oktaContext = useOktaAuth();
  const location = useLocation();

  const authState = oktaContext?.authState;
  const isAuthorized = useIsAuthorized();
  if (!authState?.isAuthenticated || !isAuthorized) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate state={{ from: location }} to="/login" />;
  }

  return children;
}
